export default {
  methods: {
    addressToString({ address1, address2, address3 }) {
      return [
        address1,
        ...(Array.isArray(address2) ? address2 : [address2]),
        ...(Array.isArray(address3) ? address3 : [address3]),
      ].join(', ');
    },
  },
};
